import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Queue {
  id: string;
  name: string;
  extension: string;
}

interface QueueState {
  items: Queue[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: QueueState = {
  items: [],
  status: "idle",
  error: null,
};

const queueSlice = createSlice({
  name: "queue",
  initialState,
  reducers: {
    setQueues: (state, action: PayloadAction<Queue[]>) => {
      state.items = action.payload;
      state.status = "succeeded";
      state.error = null;
    },
    setQueuesLoading: (state) => {
      state.status = "loading";
      state.error = null;
    },
    setQueuesError: (state, action: PayloadAction<string>) => {
      state.status = "failed";
      state.error = action.payload;
    },
    resetQueues: (state) => {
      state.items = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const {
  setQueues,
  setQueuesLoading,
  setQueuesError,
  resetQueues,
} = queueSlice.actions;

export default queueSlice.reducer;
